import { useAuth0 } from "@auth0/auth0-react";
import { constants } from "../../config";
import Loader from "../usercontrols/loader/loader";

const AuthLogin = () => {
  const { loginWithRedirect } = useAuth0();

  loginWithRedirect({
    authorizationParams: {
      redirectUri: window.location.origin,
      connection: constants.AUTH0_CONNECTION,
      audience: constants.AUTH0_AUDIENCE,
      scope: "openid profile email offline_access read:getServices",
    },
    appState: {
      returnTo: window.location.pathname,
    },
  });

  return <Loader />;
};

export default AuthLogin;
